var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"documentation_frame",attrs:{"src":"https://dev.api.oddscrowd.ronasit.com/se5f34t34634n5746gyf4e5yf4r6uy4nb5y4t"}})
}
var staticRenderFns = []

export { render, staticRenderFns }